import React, { Component } from "react";
import { connect } from "react-redux";
import { selectShipment } from "../../actions/select_actions";

import { Box } from "reflexbox";
import CarrierHoverCard from "../Carriers/_CarrierHoverCard";
import ShipmentStatus from "./_ShipmentStatus";
import ToggleShipmentAttachmentDialog from "../../common/Buttons/_ToggleShipmentAttachmentDialog";
import ToggleShipmentStatusCallout from "../../common/Buttons/_ToggleShipmentStatusCallout";

import { Icon } from "office-ui-fabric-react/lib/Icon";
import { IconButton } from "office-ui-fabric-react/lib/Button";

class ShipmentCard extends Component {
  render() {
    const { item, shipment } = this.props;

    return (
      <div>
        <Box
          flex
          justify="space-between"
          style={{
            minHeight: "80px",
            fontSize: "small",
            marginTop: "5px",
            borderLeft: `5px solid ${item.relationByRelationId.color}`,
            backgroundColor: item.id === shipment.id ? "#edffff" : "#dff7cd",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
            transition: "0.7s"
          }}
          onClick={e => {
            e.preventDefault();
            this.props.selectShipment(item);
          }}
        >
          <Box m={1}>
            <Box flex>
              <Box>{item.date}</Box>
              {/* <Box style={{fontSize: 'x-small'}}>{`Dossier nr: ${item.id}`}</Box> */}
            </Box>

            <Box>
              {item.relationByRelationId &&
                item.cargoTypeByCargoTypeId && (
                  <Box flex>
                    <Box style={{ fontWeight: "bold" }}>
                      {item.relationByRelationId.name.toUpperCase()}
                    </Box>
                    <Box ml={1} style={{ fontSize: "10px" }}>
                      {item.cargoTypeByCargoTypeId.type.toUpperCase()}
                    </Box>
                  </Box>
                )}
            </Box>
            <CarrierHoverCard carrier={item.carrierByCarrierId} />
            <Box flex>
              <Box>
                <ShipmentStatus shipment={item} />
              </Box>
              <Box ml={1}>
                {item.storagesByShipmentId.nodes.length > 0 ? (
                  <div>
                    <Icon iconName="Attach" />
                    {item.storagesByShipmentId.nodes.length}
                  </div>
                ) : null}
              </Box>
            </Box>
          </Box>
          <Box column>
            <div>
              {this.props.shipment.id === item.id && (
                <ToggleShipmentStatusCallout item={item} />
              )}
            </div>
            <div>
              {this.props.shipment.id === item.id && (
                <ToggleShipmentAttachmentDialog buttonType="action" />
              )}
            </div>
          </Box>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(
  mapStateToProps,
  {
    selectShipment: selectShipment
  }
)(ShipmentCard);



// WEBPACK FOOTER //
// ./src/views/Shipments/_ShipmentCard.js